// Draft Order Monitor Utility - Now uses efficient app-level monitoring
// Preserves React Scripts caching while providing smart draft monitoring

import efficientDraftMonitor from './efficientDraftMonitor';

export const DraftOrderMonitor = {
  // Initialize the efficient draft monitoring system
  init() {
    console.info('Initializing efficient app-level draft monitoring');
    efficientDraftMonitor.init();
  },

  // Manual trigger for testing
  checkDraftsNow() {
    efficientDraftMonitor.manualCheck();
  },

  // Get current order data (for backwards compatibility)
  async getCurrentOrderData() {
    return efficientDraftMonitor.getCurrentDraftData();
  },

  // Get monitoring status
  getStatus() {
    return efficientDraftMonitor.getStatus();
  },

  // Legacy methods (no-op for backwards compatibility)
  isCustomServiceWorkerActive() {
    return false; // Always false since we're using app-level monitoring
  },

  startMonitoring() {
    // No-op - monitoring starts automatically
  },

  stopMonitoring() {
    // No-op - monitoring is event-driven
  },

  syncCurrentOrderToServiceWorker() {
    // No-op - no service worker communication needed
  },

  startOrderDataSync() {
    // No-op - efficient monitoring handles this
  },
};

// Auto-initialize
if (typeof window !== 'undefined') {
  setTimeout(() => {
    DraftOrderMonitor.init();
  }, 3000);
}

// Expose to window for debugging
if (typeof window !== 'undefined') {
  window.DraftOrderMonitor = DraftOrderMonitor;
  window.EfficientDraftMonitor = efficientDraftMonitor;
}

export default DraftOrderMonitor;
